/**
 * Que permissão abre cada parte de Acessos — fonte única para o menu
 * lateral, a aba de Configurações, as abas e as rotas desta área.
 *
 * Antes Usuários, Cargos e SoD eram só do Master na tela, embora as
 * permissões fossem concedíveis: o gestor marcava `usuario:view` e nada
 * abria (auditoria RBAC 2026-10-08). Cada botão das fichas confere a
 * permissão do seu endpoint (ver os `podeX` nas telas).
 */

export const PERMS_HUB_ACESSOS = ["usuario:view", "cargo:view", "permissao:view"];

export const PERMS_ABA_ACESSOS = {
  hub: PERMS_HUB_ACESSOS,
  usuarios: ["usuario:view"],
  cargos: ["cargo:view"],
  auditoria: ["auditoria:view"],
  sod: ["permissao:view"],
};

/** Qualquer uma destas deixa entrar na área de Acessos. */
export const PERMS_ENTRAR_ACESSOS = [...PERMS_HUB_ACESSOS, "auditoria:view"];
